import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PotvrdaOPrijaviSteteDocument} from "./PotvrdaOPrijaviSteteDocument";
import {PrigovorZaStetuDocument} from "./PrigovorZaStetuDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga
export const prigovorZaStetuDocumentFields: IntercateKeysMap<PrigovorZaStetuDocument, EntityField<PrigovorZaStetuDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PrigovorZaStetuDocument>> = [
	prigovorZaStetuDocumentFields.indexingNumber,
	prigovorZaStetuDocumentFields.indexingDate,
	prigovorZaStetuDocumentFields.documentNumber,
	prigovorZaStetuDocumentFields.documentDate,
	prigovorZaStetuDocumentFields.assignedTo,
	prigovorZaStetuDocumentFields.clientId,
	prigovorZaStetuDocumentFields.sectorId,
	prigovorZaStetuDocumentFields.tags,
	prigovorZaStetuDocumentFields.description,
	prigovorZaStetuDocumentFields.parentId
]

export const prigovorZaStetuDocumentFieldsDescriptor: EntityFieldsDescriptor<PrigovorZaStetuDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
